import React from 'react';
import { StarIcon, QuoteIcon } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    name: 'Lucas M.',
    city: 'Buenos Aires',
    quote: 'Ahora entiendo lo que hago cuando corto. Antes copiaba videos y rezaba para que quede bien. El método me dio la estructura que me faltaba.',
    rating: 5
  }, {
    name: 'Matias R.',
    city: 'Córdoba',
    quote: 'Mis fades mejoraron muchísimo en solo dos semanas. La forma en que explican la teoría detrás de cada paso te cambia la cabeza.',
    rating: 5
  }, {
    name: 'Ezequiel G.',
    city: 'Rosario',
    quote: 'Empecé a cobrar mejor porque mis cortes ahora se ven profesionales. Dejé de dudar con las tijeras y gano tiempo en cada cliente.',
    rating: 5
  }, {
    name: 'Facundo S.',
    city: 'Mendoza',
    quote: 'Le dio estructura a lo que ya sabía. Pensé que no necesitaba teoría hasta que leí el manual. Recomendado al 100%.',
    rating: 5
  }];
  return <section className="w-full bg-[#0f0f0f] py-20 md:py-32 px-4 relative border-t border-white/5" data-id="element-344">
      <div className="max-w-6xl mx-auto" data-id="element-345">
        <div className="text-center mb-16 md:mb-24" data-id="element-346">
          <h2 className="text-3xl md:text-5xl lg:text-6xl font-black text-white leading-tight mb-6" data-id="element-347">
            +2.500 barberos ya están{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#c9a24a] to-[#b8913f]" data-id="element-348">
              mejorando
            </span>
          </h2>
          <p className="text-gray-400 text-lg md:text-2xl font-medium max-w-2xl mx-auto" data-id="element-349">
            Resultados reales de quienes ya aplicaron el método en sus
            barberías.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8" data-id="element-350">
          {testimonials.map((testimonial, index) => <div key={index} className="bg-[#141418] border border-white/10 rounded-2xl p-6 md:p-8 hover:border-[#c9a24a]/30 transition-colors relative group backdrop-blur-sm" data-id="element-351">
              <QuoteIcon className="absolute top-6 right-6 w-8 h-8 md:w-10 md:h-10 text-[#c9a24a]/10 group-hover:text-[#c9a24a]/20 transition-colors" data-id="element-352" />

              <div className="flex items-center gap-1 mb-4 md:mb-6" data-id="element-353">
                {[...Array(testimonial.rating)].map((_, i) => <StarIcon key={i} className="w-4 h-4 md:w-5 md:h-5 text-[#c9a24a] fill-[#c9a24a]" data-id="element-354" />)}
              </div>

              <p className="text-gray-300 text-sm md:text-base leading-relaxed mb-6 md:mb-8 font-medium italic" data-id="element-355">
                "{testimonial.quote}"
              </p>

              <div className="mt-auto pt-4 border-t border-white/10" data-id="element-356">
                <p className="text-white font-bold text-base md:text-lg" data-id="element-357">
                  {testimonial.name}
                </p>
                <p className="text-[#c9a24a] text-xs md:text-sm font-semibold" data-id="element-358">
                  {testimonial.city}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}